import styled from '@emotion/styled';

import Image from 'components/Image';

interface IImageProps {
  leftImageSrc?: string;
  rightImageSrc?: string;
}

export const ContentBox = styled.div`
  max-width: ${({ theme }) => theme.maxWidth.xl};
  margin: 100px auto;
  position: relative;
  ${({ theme }) => theme.breakpoints.lg} {
    margin: 80px 0px;
  }
`;

export const ContentImageWrapper = styled.div`
  position: absolute;
  z-index: 2;
  height: 450px;
  width: 450px;
  top: -50px;
  right: ${(props: IImageProps) => (props.rightImageSrc ? '-30px' : '')};
  ${({ theme }) => theme.breakpoints.lg} {
    display: none;
  }
`;

export const Content = styled.div`
  padding: 25px;
  position: relative;
  background: ${({ theme }) => theme.colors.secondary.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding-left: ${(props: IImageProps) => (props.leftImageSrc ? '180px' : '25px')};
  padding-right: ${(props: IImageProps) => (props.rightImageSrc ? '230px' : '25px')};
  ${({ theme }) => theme.breakpoints.lg} {
    padding: ${(props: IImageProps) =>
      props.leftImageSrc || props.rightImageSrc ? '10px' : '25px'};
  }
  height: 100%;
`;

export const ContentImage = styled(Image)`
  object-fit: contain;
`;

export const ContentWrapper = styled.div`
  background: ${({ theme }) => `linear-gradient(
        to right,
        ${theme.colors.primary.orange} 15px,
        transparent 15px
      )
      0 0,
    linear-gradient(to right, ${theme.colors.primary.orange} 15px, transparent 15px) 0 100%,
    linear-gradient(to left, ${theme.colors.primary.orange} 15px, transparent 15px) 100% 0,
    linear-gradient(to left, ${theme.colors.primary.orange} 15px, transparent 15px) 100% 100%,
    linear-gradient(to bottom, ${theme.colors.primary.orange} 15px, transparent 15px) 0 0,
    linear-gradient(to bottom, ${theme.colors.primary.orange} 15px, transparent 15px) 100% 0,
    linear-gradient(to top, ${theme.colors.primary.orange} 15px, transparent 15px) 0 100%,
    linear-gradient(to top, ${theme.colors.primary.orange} 15px, transparent 15px) 100% 100%`};
  background-repeat: no-repeat;
  background-size: 50px 100%;
  padding: 15px;
  margin-left: ${(props: IImageProps) => (props.leftImageSrc ? '260px' : '0')};
  margin-right: ${(props: IImageProps) => (props.rightImageSrc ? '180px' : '0')};
  ${({ theme }) => theme.breakpoints.lg} {
    margin: 0;
  }
  height: 100%;
`;
